(function () {
  window._learnq = window._learnq || [];

  function getCompanyId() {
    var script = document.querySelector('script[src*="klaviyo.js?"]');
    if (!script) return null;
    try {
      return new URL(script.src).searchParams.get('company_id');
    } catch (e) {
      return null;
    }
  }

  function identify(email, firstName, lastName) {
    var profile = { $email: email };
    if (firstName) profile.$first_name = firstName;
    if (lastName) profile.$last_name = lastName;
    window._learnq.push(['identify', profile]);
  }

  function trackEvent(name, properties) {
    window._learnq.push(['track', name, properties]);
  }

  function subscribeToList(email, listId, companyId) {
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
          },
          relationships: { list: { data: { type: 'list', id: listId } } },
        },
      }),
    }).catch(function () {});
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (form.classList.contains('newsletter-form')) {
      var emailEl = form.querySelector('input[type="email"]');
      if (!emailEl) return;
      var email = emailEl.value.trim();
      if (!email) return;

      identify(email);

      var listId = window.theme && window.theme.klaviyo && window.theme.klaviyo.newsletterListId;
      var companyId = getCompanyId();
      if (listId && companyId) subscribeToList(email, listId, companyId);
    }

    if (form.id && form.id.indexOf('ContactForm-') === 0) {
      var emailEl = form.querySelector('input[type="email"]');
      if (!emailEl) return;
      var email = emailEl.value.trim();
      if (!email) return;

      var nameEl = form.querySelector('input[autocomplete="name"]');
      var fullName = nameEl ? nameEl.value.trim() : '';
      var parts = fullName.split(' ');
      var firstName = parts[0] || '';
      var lastName = parts.slice(1).join(' ') || '';

      identify(email, firstName, lastName);
      trackEvent('Contact Form Submitted', {
        $email: email,
        'First Name': firstName,
        'Last Name': lastName,
      });
    }
  });
})();
